import { createSlice } from '@reduxjs/toolkit';

export type DashboardStore = {};

const initialState: DashboardStore = {};

const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState,
  reducers: {},
  extraReducers: builder => {},
});

// export const {} = authSlice.actions;

const authReducer = dashboardSlice.reducer;

export default authReducer;
